import {Directive, TemplateRef, ViewContainerRef} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';
// Je nach UserAgent werden Elemente ausgegeben
// Beispiel:
// <video *isTablet></video>
@Directive({
  selector: '[isTablet]'
})
export class IsTabletDirective {

  constructor(private deviceService: DeviceDetectorService,
              private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef) {
  }

  ngOnInit(): void {
    if (this.deviceService.isTablet() || this.deviceService.isDesktop()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

}
